
<div class="copo-section-header">
	<h2 mat-dialog-title class="copo-popup-title">
		<mat-icon class="icon-style" [svgIcon]="data.iconName" [attr.title]="'offline.alert' | translate"></mat-icon>
		<span class="title-content">{{data.title | translate}}</span>
		<button type="button" class="close-icon" mat-icon-button [mat-dialog-close]="false">
			<mat-icon svgIcon="md:close"></mat-icon>
		</button>
	</h2>
</div>
<mat-dialog-content>
	<div class="copo-simple-dialog-content">
		<div>
			<span *ngFor="let content of data.contents" [innerHTML]="content"></span>
		</div>
	</div>
</mat-dialog-content>
<mat-dialog-actions class="button-group">
	<button *ngIf="data.cancelButtonEnabled" type="button" mat-button [mat-dialog-close]="false" class="copo-button">
		<span translate>filter.cancel</span>
	</button>
	<button type="submit" mat-button [mat-dialog-close]="true" class="copo-blue-dark-grey-button">
		<span translate>navig.confirm</span>
	</button>
</mat-dialog-actions>